export const SUB_TASK_COMPLETION_BLOCKED_CODE = 'SubTaskCompletionBlocked';

/** The reason is the refusal the sub-task's own write would have met, so the user can resolve it and try again. */
export interface BlockedSubTask {
    taskId: string;
    name: string;
    reason: string;
}

export interface SubTaskCompletionRefusal {
    blockedSubTasks: BlockedSubTask[];
}

/** Plain text that stands alone, for a client that shows only the message of a 400. */
export function describeSubTaskCompletionRefusal(refusal: SubTaskCompletionRefusal): string {

    return `Nothing was completed. These sub-tasks cannot be completed: ${refusal.blockedSubTasks.map(blocked => `${blocked.name} (${blocked.reason})`).join(', ')}`;
}
